import { clientFeatures } from './client-features/client-features.test';

export const environment = {
  productionEnv: false,
  clientFeatures,
  backendBaseUrl: '/api',
  vacationHomesServicesBackendBaseUrl:
    'https://api-test.ip-only.net/consumer-vacation-home-backend',
  globalConnectSe: {
    selfserviceHost: 'selfservice-test.globalconnect.se',
    publicWebHost: 'https://privat-test.globalconnect.se/',
    googleTagManagerId: '',
    backendHost: 'selfservice-test.globalconnect.se',
    integrityPolicyLink: 'https://globalconnect.se/privat-integritetspolicy/',
    customerServicePhoneNumber: '0200-430000',
    leisureHomeUrl: 'https://selfservice-test.globalconnect.se/fritidshus',
  },
  globalConnectSeHub: {
    selfserviceHost: 'selfservice-test.globalconnect.se',
    publicWebHost: 'https://selfservice-test.globalconnect.se/adressök',
    googleTagManagerId: '',
    backendHost: 'selfservice-test.globalconnect.se',
  },
  globalConnectFi: {
    selfserviceHost: 'aktivointi-test.globalconnect.fi',
    publicWebHost: 'https://koti-test.globalconnect.fi/',
    googleTagManagerId: '',
    backendHost: 'aktivointi-test.globalconnect.fi',
    integrityPolicyLink:
      'https://koti-test.globalconnect.fi/tietosuojakaytanto/',
    customerServicePhoneNumber: '0942414200',
  },
  keycloakConfig: {
    url: 'https://accounts-test.globalconnect.net/auth',
    realm: 'public',
    clientId: 'selfservice-hub',
  },
  providers: [],
};
